export function timeAgo(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  const s = Math.floor((Date.now() - d.getTime()) / 1000);
  if (s < 60) return "just now";
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  if (s < 604800) return `${Math.floor(s / 86400)}d ago`;
  return d.toLocaleDateString(undefined, { month: "short", day: "numeric" });
}

export function initials(name) {
  if (!name) return "?";
  return name.slice(0, 2).toUpperCase();
}

export const PRIORITIES = [
  { value: "low", label: "Low", color: "#a1a1aa" },
  { value: "medium", label: "Medium", color: "#0284c7" },
  { value: "high", label: "High", color: "#d97706" },
  { value: "urgent", label: "Urgent", color: "#e84e34" },
];

export const priorityColor = (p) => PRIORITIES.find((x) => x.value === p)?.color || "#a1a1aa";

export const PRICE_UNITS = [
  { value: "unit", label: "Per unit" },
  { value: "case", label: "Per case" },
  { value: "oz", label: "Per oz" },
  { value: "lb", label: "Per lb" },
];

export const priceUnitLabel = (v) => PRICE_UNITS.find((x) => x.value === v)?.label || "Per unit";
export const money = (n) => (n == null || n === "" ? "—" : `$${Number(n).toFixed(2)}`);

export const TAGS = [
  { value: "potential", label: "Potential", color: "#d97706", bg: "#fef3c7" },
  { value: "rejected", label: "Rejected", color: "#e84e34", bg: "#fdece8" },
  { value: "approved", label: "Approved", color: "#16a34a", bg: "#dcfce7" },
];
export const tagMeta = (v) => TAGS.find((t) => t.value === v);
export const cogsOf = (costs) => (costs || []).reduce((s, c) => s + (Number(c.amount) || 0), 0);
export const marginPct = (rrp, costs) => {
  const r = Number(rrp);
  if (!r) return null;
  return ((r - cogsOf(costs)) / r) * 100;
};

// Equipment cost = sum of custom line items (fallback to legacy purchase_cost).
export const equipmentTotal = (e) => {
  const items = (e && e.cost_items) || [];
  if (items.length) return items.reduce((s, i) => s + (Number(i.amount) || 0), 0);
  return Number(e && e.purchase_cost) || 0;
};
export const equipmentPerUnit = (e) => {
  const units = Number(e && e.units) || 1;
  return equipmentTotal(e) / (units > 0 ? units : 1);
};
// Only elements that have been rated contribute; weights bias the average.
export function locationScore(loc, elements) {
  const scores = (loc && loc.scores) || {};
  let num = 0, wsum = 0, simple = 0, rated = 0;
  (elements || []).forEach((el) => {
    const v = scores[el.id];
    if (v != null && v !== "") {
      const w = Number(el.weight) || 0;
      const val = Number(v) || 0;
      num += val * w; wsum += w; simple += val; rated += 1;
    }
  });
  const score = wsum > 0 ? num / wsum : (rated > 0 ? simple / rated : 0);
  return { score, rated, hasScore: rated > 0 };
}
